// extracted by mini-css-extract-plugin
export default {"info_card_section":"Delivery_info_card_section__lpF1u","spin":"Delivery_spin__w2heT"};